import React from 'react';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

const Contact = () => {
  return (
    <>
      <div className="pages contact">
        <h1 className="title">Contact Us</h1>
      </div>
      <div className="map">
        <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3444.159016040667!2d79.6701516!3d29.5171625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDMxJzAxLjgiTiA3OcKwNDAnMTIuNSJF!5e0!3m2!1sen!2sin!4v1693234521000!5m2!1sen!2sin"
  width="100%"
  height="300"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
></iframe>
      </div>
      <ContactUs />
      <Footer />
    </>
  )
}

export default Contact
